/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

import { StatusCode } from "../../models/apiModels/Tenant";
import { StepperDTO } from "../../models/componentModels/StepperDTO";

export function getStepperbyStatus(status: StatusCode): StepperDTO {
  let initialStepperState: StepperDTO = {
    currentStep: "undefined",
    steps: [
      {
        id: "CreateTenant",
        status: undefined,
        title: "Enter Tenant Details",
      },
      {
        id: "Settings",
        status: undefined,
        title: "Add Parameters",
      },
      {
        id: "Summary",
        status: undefined,
        title: "Summary",
      },
    ],
  };

  if (status === StatusCode.InIt) {
    initialStepperState = {
      ...initialStepperState,
      currentStep: "Settings",
      steps: initialStepperState.steps.map((step) => {
        if (step.id === "CreateTenant") {
          return { ...step, status: "valid" };
        }
        return step;
      }),
    };

    return initialStepperState;
  } else if (status === StatusCode.InProgress) {
    initialStepperState = {
      ...initialStepperState,
      currentStep: "Settings",
      steps: initialStepperState.steps.map((step) => {
        if (step.id === "CreateTenant") {
          return { ...step, status: "valid" };
        }
        return step;
      }),
    };
    return initialStepperState;
  } else if (status === StatusCode.noTenant) {
    initialStepperState = {
      ...initialStepperState,
      currentStep: "CreateTenant",
      steps: initialStepperState.steps.map((step) => {
        if (step.id === "CreateTenant") {
          return { ...step, status: undefined };
        }
        return step;
      }),
    };
    return initialStepperState;
  } else {
    return initialStepperState;
  }
}
